import React from 'react';
import { Construction } from 'lucide-react'; // Using a relevant icon

interface UnderDevelopmentPlaceholderProps {
  pageName?: string;
  className?: string;
}

const UnderDevelopmentPlaceholder: React.FC<UnderDevelopmentPlaceholderProps> = ({
  pageName,
  className = '',
}) => {
  const title = pageName ? `${pageName} Page` : 'Page';

  return (
    <div
      className={`flex h-64 flex-col items-center justify-center rounded-lg border-2 border-dashed border-yellow-400 bg-yellow-50 p-8 text-center text-yellow-700 dark:border-yellow-600 dark:bg-yellow-900/20 dark:text-yellow-400 ${className}`}
    >
      <Construction className="mb-4 h-12 w-12" />
      <h2 className="mb-2 text-xl font-semibold">
        {title} - Under Development
      </h2>
      <p className="text-sm">This feature is coming soon!</p>
    </div>
  );
};

export default UnderDevelopmentPlaceholder;
